/* eslint-disable array-callback-return */
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { URL_API } from "config";
import { Box, Icon, LinearProgress, List } from "@mui/material";

import './spinner.css';
import { useAuthContext } from "context/AuthContext";
import NotificationItem from "examples/Items/NotificationItem";
import DataPaginateTable from "examples/Tables/DataPaginateTable";
import moment from "moment";
import { io } from "socket.io-client";

const socket = io(URL_API);

function NotificationTable() {
  const [sendMessages, setSendMessages] = useState([]);
  const [rowSelected, setRowSelected] = useState();
  const [loading, setLoading] = useState(false);
  const [tableLimit, setTableLimit] = useState(10);
  const [tablePage, setTablePage] = useState(1);
  const [tableTotal, setTableTotal] = useState(0);
  const [count, setCount] = useState(0);

  const navigate = useNavigate();

  let tag = localStorage.getItem("Tag");

  const { user } = useAuthContext();

  const dataTableData = {
    columns: [
      { Header: "Data", accessor: "created_at" },
      { Header: "Mensagem", accessor: "message" },
      { Header: "Ações", accessor: "action", width: "7%" },
    ],
    rows: sendMessages,
  };

  useEffect(() => {
    if (user) {
      (async () => {
        setLoading(true);

        await getSendMessagesByUser(tablePage, tableLimit);

        setLoading(false);
      })()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, tablePage, tableLimit, count]);

  async function getSendMessagesByUser(tablePage, tableLimit) {
    await axios.get(URL_API + `/send-messages?page=${tablePage}&limit=${tableLimit}`, {
      headers: {
        Authorization: `Bearer ${tag}`,
      },
    }).then(function (response) {
      for (const message of response?.data?.data) message.created_at = moment(message.created_at).format('DD/MM/YYYY - HH:mm');

      setSendMessages(response.data.data);
      setTableTotal(response?.data.meta?.total);
    }).catch(function (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("Tag");
        navigate("/auth/login");
      } else {
        toast.error(error?.response?.data?.message);
      }
    });
  }

  useEffect(() => {
    socket.on("notification", (message) => {
      if (message.company_id === user.company_id) {
        setSendMessages([...sendMessages, message])

        setTableLimit(10)
        setTablePage(1)
        setTableTotal(0)
        setCount(count + 1)
      }
    });
    // eslint-disable-next-line
  }, [sendMessages])

  const getCooperated = async (guid) => {
    try {
      const response = await axios.get(URL_API + `/cooperated/${guid}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Tag")}`,
        },
      });

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  const updateSendMessagesByUser = async () => {
    await axios.put(URL_API + `/send-messages/${user?.uuid}`, {},
      {
        headers: {
          Authorization: `Bearer ${tag}`,
        },
      }).then().catch(function (error) {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      });
  }

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox pt={2}>
              <MDBox
                p={3}
                lineHeight={1}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h5" fontWeight="medium">
                  Notificações
                </MDTypography>
              </MDBox>
            </MDBox>
          </Card>

          <MDBox pt={5}>
            <List sx={{ bgcolor: sendMessages.length && 'background.paper', borderRadius: '6px' }}>
              {
                loading ?
                  <Box sx={{ width: '100%' }}>
                    <LinearProgress sx={{ overflow: 'hidden' }} />
                  </Box> :
                  <DataPaginateTable
                    entriesPerPage={{ defaultValue: tableLimit }}
                    table={dataTableData}
                    onRowSelected={setRowSelected}
                    setTableLimit={setTableLimit}
                    tableLimit={tableLimit}
                    setTablePage={setTablePage}
                    tablePage={tablePage}
                    tableTotal={tableTotal}
                  >
                    {[
                      <NotificationItem
                        onClick={async () => {
                          await updateSendMessagesByUser();

                          const res = await getCooperated(rowSelected.original.cooperated_uuid);

                          if (!res) return toast.info('Colaborador não encontrado.');

                          navigate("/admin/cooperateds/update/" + rowSelected.original.cooperated_uuid);
                        }}
                        icon={<Icon>create</Icon>}
                        title="Editar"
                      />
                    ]}
                  </DataPaginateTable>
              }
            </List>
          </MDBox>
        </MDBox>
      </DashboardLayout>
      <ToastContainer />
    </>
  );
}

export default NotificationTable;
